import React from "react";
import styles from "./styles.css";

const Button = ({ text, onClick, disabled, className, children, style, type }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={`button-container ${className}`}
      type={type}
    >
      {text}
      {children}
    </button>
  );
};

export default Button;
